// https://github.com/vuetifyjs/vuetify/issues/21693
// https://dev.azure.com/kpmgsofy/SOFY/_workitems/edit/43865
// This bug causes duplicate ids for directive tooltips, breaking validation and accessibility.
// As a temporary fix, we use a hover-tooltip directive that mounts VTooltip programmatically until Vuetify resolves the issue.

import { h, render } from 'vue';
import { VTooltip } from 'vuetify/components';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('hover-tooltip', {
    mounted(el, binding) {
      const position = binding.arg || 'bottom';
      const container = document.createElement('div');
      document.body.appendChild(container);

      const tooltipVNode = h(VTooltip, {
        text: binding.value,
        location: position,
        activator: el
      });

      tooltipVNode.appContext = nuxtApp.vueApp._context;

      // Render asynchronously to avoid parent validation errors
      Promise.resolve()
        .then(() => {
          render(tooltipVNode, container);
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.error(`Error rendering hover-tooltip - ${binding.value} - ${el.id}: `, error);
          if (container && container.parentNode) {
            container.remove();
          }
        });

      // Store references for cleanup
      el._tooltip = { container, vnode: tooltipVNode };
    },

    updated(el, binding) {
      if (el._tooltip && binding.oldValue !== binding.value) {
        el._tooltip.vnode.component.props.text = binding.value;
      }
    },

    unmounted(el) {
      if (el._tooltip) {
        render(null, el._tooltip.container);
        el._tooltip.container.remove();
        delete el._tooltip;
      }
    }
  });
});
